module.exports = __webpack_public_path__ + "static/media/card-unimed2.423c8b4a.png";